export default __webpack_public_path__ + "images/2ce29588e23a3a93db93b53217a5880d.svg";